const PageBillingMain = () => import('./PageBillingMain');
const PageLPBillingsDetail = () => import('./pages/detail/PageLPBillingsDetail');
const PageBilligUpload = () => import('./pages/upload/PageBillingUpload');
const PageMyBillingsFiles = () => import('./pages/files/PageMyBillingsFiles');
const PageBillingTemplates = () => import('./pages/templates/PageBillingTemplates');

export default {
  path: 'billing',
  children: [
    {
      path: '',
      name: 'billing-main-page',
      component: PageBillingMain,
    },
    {
      path: 'logistic-providers/:id',
      name: 'billing-logistic-provider-page',
      component: PageLPBillingsDetail,
    },
    {
      path: 'upload',
      name: 'billing-upload-page',
      component: PageBilligUpload,
    },
    {
      path: 'files',
      name: 'billing-my-files-page',
      component: PageMyBillingsFiles,
    },
    {
      path: 'template',
      name: 'create-billing-template',
      component: PageBillingTemplates,
      meta: {
        title: 'Cadastro de templates',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/routes.js